export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (to.matched.length === 0) {
    const { data: currentSite } = await useApi("/api/sites")
    return navigateTo(currentSite.value.notFoundUrl, {
      external: true,
      redirectCode: 302,
    })
  }
})
